import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutLogReaderPopout extends Layout {
	layoutChart: Layout;
}
